import { useEffect, useRef } from 'react';

const services = [
  {
    section: 'BRAND',
    title: '브랜드 전략',
    sub: '시장을 읽고, 포지션을 만든다',
    desc: '시장 데이터 분석과 경쟁 포지셔닝을 통해 브랜드만의 고유한 아이덴티티와 커뮤니케이션 전략을 수립합니다. CI/BI 설계부터 메시지 아키텍처까지 통합 지원합니다.',
    tags: ['Identity', 'Positioning', 'CI/BI'],
    col: '#C8102E',
  },
  {
    section: 'SOCIAL',
    title: 'SNS 마케팅',
    sub: '알고리즘을 이해하는 콘텐츠',
    desc: '인스타그램·유튜브·틱톡 채널 알고리즘을 실시간 분석해 최적의 콘텐츠 전략을 실행합니다. 데이터 기반으로 팔로워 성장과 높은 인게이지먼트를 동시에 달성합니다.',
    tags: ['Instagram', 'YouTube', 'TikTok'],
    col: '#1A1818',
  },
  {
    section: 'ADS',
    title: '퍼포먼스 광고',
    sub: 'ROAS를 극대화하는 과학적 접근',
    desc: '구글·메타·카카오 광고 시스템을 실시간 모니터링하고 최적화합니다. 수익이 나지 않는 캠페인은 즉시 감지하고 개선해 예산 낭비 없이 성과를 만듭니다.',
    tags: ['Google Ads', 'Meta Ads', 'ROAS'],
    col: '#C8102E',
  },
  {
    section: 'CONTENT',
    title: '콘텐츠 제작',
    sub: '브랜드 세계관을 시각화한다',
    desc: '기획부터 촬영, 후반 작업까지 원스톱으로 진행합니다. 영상, 사진, 모션그래픽을 통해 브랜드 아이덴티티를 모든 접점에서 일관되게 표현합니다.',
    tags: ['Video', 'Photography', 'Motion'],
    col: '#1A1818',
  },
  {
    section: 'SEO',
    title: 'SEO / 검색',
    sub: '검색 상위를 점령하는 기술',
    desc: '기술적 SEO, 콘텐츠 최적화, 링크 빌딩을 통합해 자연 유입 트래픽을 지속 성장시킵니다. 단기 성과가 아닌 장기적 검색 권위를 구축합니다.',
    tags: ['Technical SEO', 'Content', 'Link Building'],
    col: '#C8102E',
  },
  {
    section: 'CRM',
    title: 'CRM 마케팅',
    sub: '고객 데이터로 LTV를 높인다',
    desc: '고객 행동 데이터를 세밀하게 분석해 개인화된 자동화 마케팅 플로우를 설계합니다. 이메일, 앱 푸시, SMS를 통합해 재구매율과 LTV를 극대화합니다.',
    tags: ['Email', 'Automation', 'Segmentation'],
    col: '#1A1818',
  },
];

export default function Services() {
  const ref = useRef(null);
  useEffect(() => {
    const cards = ref.current?.querySelectorAll('[data-card]');
    if (!cards) return;
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.style.opacity='1'; obs.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    cards.forEach((c, i) => {
      c.style.opacity = '0';
      c.style.transition = `opacity 0.5s ease ${i * 0.07}s`;
      obs.observe(c);
    });
    return () => obs.disconnect();
  }, []);

  return (
    <div className="py-16">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section masthead */}
        <div className="flex items-center gap-4 mb-2">
          <div className="bg-ink text-paper font-sans text-xs font-black tracking-widest px-3 py-1.5 uppercase">
            서비스 섹션
          </div>
          <div className="border-t border-rule-2 flex-1" />
          <span className="font-mono text-xs text-dim">SERVICE COVERAGE</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0">
          {services.map(s => (
            <div key={s.section} data-card
              className="border-r border-b border-rule-2 p-6 group hover:bg-paper-2 transition-colors duration-200">
              <div className="flex items-center justify-between mb-4">
                <span className="font-mono text-xs font-bold text-red tracking-widest">{s.section}</span>
              </div>
              <div className="w-full mb-4" style={{ borderTopWidth:'2px', borderTopStyle:'solid', borderTopColor: s.col }} />
              <h3 className="font-headline font-bold text-xl text-ink mb-1 group-hover:italic transition-all duration-200">
                {s.title}
              </h3>
              <p className="font-serif text-sm italic text-dim mb-3">{s.sub}</p>
              <p className="font-sans text-sm text-dim leading-relaxed mb-4">{s.desc}</p>
              <div className="flex flex-wrap gap-2">
                {s.tags.map(t => (
                  <span key={t} className="font-mono text-xs border border-rule-2 px-2 py-0.5 text-dim group-hover:border-ink group-hover:text-ink transition-colors duration-200">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
